import React from 'react';

export const Instruction1 = () => {
  return (
    <div className="package-instruction__content">
      <p>Welcome to the UCAT Practice Test.</p>
      <p>
        The exam content and introduction screens of these exams are designed to replicate as much as possible the
        official UCAT exam.
      </p>
      <p>
        Apart from this screen, the others you will see are specific to the live exam. They are provided for your
        information.
      </p>
      <p>Please note:</p>
      <ul>
        <li>The practice tests will not save your result or provide a scale score.</li>
        <li>
          The final review screen (which will not appear in the live exam) indicates which of your answers are correct /
          incorrect.
        </li>
      </ul>

      <h6>Note Taking</h6>
      <ul>
        <li>
          If you are sitting your test at a test centre, you will be given a laminated notebook (A4 in size) and a pen.
        </li>
      </ul>

      <h6>Calculator</h6>
      <ul>
        <li>
          An onscreen calculator is available to assist you in the test. You can access this by clicking on the button
          at the top left of the screen.
        </li>
        <li>
          You can operate the calculator by using the mouse or the number pad on the keyboard; ensure that 'Num Lock’ is
          on for the number pad to work.
        </li>
        <li>
          The calculator opens in a separate window to the test screen. If you click off the calculator window back to
          the test screen (or use a keyboard shortcut, for example Alt + F to Flag for Review) the calculator will not
          function until you click back on it.
        </li>
      </ul>

      <h6>Keyboard Shortcuts</h6>
      <ul>
        <li>
          Keyboard shortcuts can be used to navigate through the test if you find this preferable to using the mouse.
        </li>
        <li>
          Wherever there is a letter underlined, the Alt key can be used with the underlined letter key as a keyboard
          short cut. For example, Alt + N = Next.
        </li>
        <li>
          If the standard shortcuts do not work for you in the practice materials this may be because of the device,
          operating system or browser you are using. You are advised to use the mouse to navigate through the test.
        </li>
      </ul>

      <p>
        The 'Navigator' function at the bottom right of the screen allows you to navigate to questions within the
        subtest.
      </p>
      <p>
        Please click the <strong>Next (N)</strong> button when you are ready to begin the practice test.
      </p>
    </div>
  );
};
